import PropTypes from 'prop-types';
import {useState} from 'react';
import {connect} from 'react-redux';
import {showOverlay} from '../../actions/overlay-actions';
import Translation from '../../lang/Translation';
import {getSettings} from '../../selectors/selectors';
import publishMetric from '../../tracking/bigQueryMetricRecorder';
import {getBrowserWidth} from '../../utils/browserUtils';
import Track from '../../utils/tracking';
import question from '../ui/svg/question.svg';
import {getTooltip} from './TooltipLibrary';
import useStyles from './DetailedTooltipIcon.styles';

const DETAILED_TOOLTIP_EVENT_KEY = 'DetailedToolTip';
const getTrackingEventAttribute = (value, tooltipID) => [{
  name: 'action',
  value: `${tooltipID}${value}`,
}];

export function DetailedTooltipIcon(props) {
  const classes = useStyles();
  const [tooltipActive, setTooltipActive] = useState(false);
  
  const isCv2Tooltip = props.tooltipID === 'CV2_TOOLTIP';
  const isMobile = getBrowserWidth() <= 767;
  
  const trackAndSetActive = (active) => {
    try {
      publishMetric(DETAILED_TOOLTIP_EVENT_KEY,
        getTrackingEventAttribute(active ? 'TooltipHover' : 'TooltipHidden', props.tooltipID));
    } catch (error) {
      Track.track(error);
    }
    setTooltipActive(active);
  };
  
  const setOverlayActive = () => {
    trackAndSetActive(!tooltipActive);
  
    if (isMobile || (props.shouldUseCv2ModalOnAllDevices && isCv2Tooltip)) {
      try {
        publishMetric(DETAILED_TOOLTIP_EVENT_KEY, getTrackingEventAttribute('OverlayOpen', props.tooltipID));
      } catch (error) {
        Track.track(error);
      }
      props.showOverlay(props.tooltipID);
    }
  };
  
  const hideTooltip = () => trackAndSetActive(false);
  
  return (
    <div className={classes.detailedTooltipIcon}>
      {
        (props.shouldUseCv2ModalOnAllDevices && isCv2Tooltip)
          ? (
            <button
              className={`${classes.button} DetailedTooltipIcon__button--${props.tooltipID}`}
              onClick={setOverlayActive}
              aria-label={Translation.getText('tooltip')}
              aria-labelledby={tooltipActive ? `tooltip-content--${props.tooltipID}` : undefined}
              aria-expanded={tooltipActive}
              type="button"
            >
              <img className={classes.image} alt="" src={question} />
            </button>
          )
          : (
            <button
              className={`${classes.button} DetailedTooltipIcon__button--${props.tooltipID}`}
              onClick={setOverlayActive}
              onBlur={hideTooltip}
              aria-label={`${props.label}: ${Translation.getText('tooltip')}`}
              aria-labelledby={tooltipActive ? `tooltip-content--${props.tooltipID}` : undefined}
              aria-expanded={tooltipActive}
              type="button"
            >
              <img className={classes.image} alt="" src={question} />
            </button>
          )
      }
      {tooltipActive && getTooltip(props.tooltipID)}
    </div>
  );
}

DetailedTooltipIcon.propTypes = {
  tooltipID: PropTypes.string.isRequired,
  shouldUseCv2ModalOnAllDevices: PropTypes.bool.isRequired,
  showOverlay: PropTypes.func.isRequired,
  label: PropTypes.string,
};

const mapStateToProps = state => ({
  shouldUseCv2ModalOnAllDevices: !!getSettings(state)?.should_use_cv2_modal_on_all_devices,
});

const mapDispatchToProps = {
  showOverlay,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailedTooltipIcon);
